"use client"

import { Heart } from "lucide-react"

const formatDate = (date) => {
  const d = new Date(date);
  return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
}

const FeaturedOfferCard = ({ property, isWishlisted, onWishlistClick }) => {
  return (
    <div className="relative w-full h-full group">
      {/* Background Image */}
      <img src={property.thumbnail || property.images[0]} alt={property.name} className="w-full h-full object-cover" />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />

      {/* Content Container */}
      <div className="absolute inset-0 p-4 flex flex-col justify-between">
        {/* Header */}
        <div className="flex justify-between items-start">
          <span className="text-white text-sm font-medium bg-black/50 px-3 py-1 rounded-full">VillaKosh Offers</span>
          <button
            onClick={(e) => {
              e.preventDefault()
              onWishlistClick(property._id)
            }}
            className="bg-white p-1.5 rounded-full shadow-md hover:scale-110 transition-transform"
          >
            <Heart
              className={`h-5 w-5 ${isWishlisted ? "text-red-500 fill-current" : "text-gray-600 hover:text-red-500"}`}
            />
          </button>
        </div>

        {/* Main Content (empty to push everything down) */}
        <div className="flex-grow" />

        {/* Bottom Section */}
        <div className="flex flex-col space-y-1">
          {/* Offer Message */}
          <h3 className="text-white text-[16px] font-bold leading-tight">
            {property.offerMessage}
          </h3>

          {/* Price and Validity/T&C Row */}
          <div className="flex justify-between items-center">
            <div className="space-y-1 text-left">
              <p className="text-gray-300 text-sm line-through">₹{property.rate}</p>
              <p className="text-sm text-gray-300">
                Valid till: {formatDate(property.offerValidTill || Date.now())}
              </p>
            </div>
            <div className="space-y-1 text-right">
              <p className="text-white text-[20px] font-bold">
                ₹{Math.round(property.rate * (1 - property.discount / 100))}/night
              </p>
              <span className="text-gray-500 text-xs">*Terms & Conditions</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeaturedOfferCard